/*
 *  I15TEMPRELEVECalcul.ts
 *
 *  Created by Sébastien Hecart on 2022-06-17 07:29:56 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import i18n from '@batical/i18n'
import { I15TEMPRELEVE_State } from '@batical/types/src'

function I15TEMPRELEVE_docalcul(state: I15TEMPRELEVE_State) {
  state.res_installationSansAppoint = i18n.t('I15TEMPRELEVE_res_installationSansAppoint2')
  if (state.in_temp_consigne <= state.in_tempExtBase) {
    state.res_tempReleveAppoint = state.in_temp_consigne
  } else {
    state.res_tempReleveAppoint =
      state.in_temp_consigne - state.in_puissance_chaudiere / (state.in_deperdition / (state.in_temp_consigne - state.in_tempExtBase))
  }

  return state
}

export default I15TEMPRELEVE_docalcul
